<template>
  <div>
    <my-dialog v-model="openModal">
      <template v-slot:content>
        <v-row>
          <v-col class="center-all">
            <h3>
              {{ $t("errors.positionError") }}
            </h3>
          </v-col>
        </v-row>
      </template>
    </my-dialog>
  </div>
</template>
<script>
import MyDialog from "@/components/generics/MyDialog"
export default {
  name: "position-error-handler",
  components: { MyDialog },
  props: {
    value: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    openModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
  },
}
</script>
  